<main id="main" class="main">
  <div class="pagetitle">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 dashboard-header">
      <div>
        <div class="d-flex align-items-center gap-2">
          <h6 class="mb-0"><i class="bi bi-grid me-1"></i><b>PANEL PRINCIPAL</b></h6>
          <p-tag value="Dashboard" severity="info"></p-tag>
        </div>
        <small class="text-muted">Accede rápidamente a las opciones DIAN autorizadas para tu usuario.</small>
      </div>
      <p-tag [value]="nombreCuenta" severity="secondary"></p-tag>
    </div>
  </div>

  <section class="section">
    <div class="row g-2 align-items-start">
      <div class="col-12 col-xl-9">
        <section class="dashboard-section dashboard-hub-section">
          <div class="dashboard-section-header">
            <div>
              <span class="dashboard-section-kicker"><i class="bi bi-grid-3x3-gap me-1"></i>Tu espacio de trabajo</span>
              <h6 class="mb-0">DIAN</h6>
              <small class="text-muted">Dashboards y operaciones habilitados para tu perfil.</small>
            </div>
            <p-tag
              [value]="'A2 Hacienda'"
              severity="secondary"
            ></p-tag>
          </div>

          @if (dashboardsDisponibles.length > 0) {
            <div class="row g-2">
              @for (dashboard of dashboardsDisponibles; track dashboard.dashboardLink) {
                <div class="col-12">
                  <article class="card dashboard-hub-card" [ngClass]="'dashboard-hub-card-' + dashboard.tono">
                    <i [class]="dashboard.icono + ' dashboard-hub-watermark'" aria-hidden="true"></i>
                    <div class="card-body">
                      <div class="dashboard-hub-card-header">
                        <div class="dashboard-hub-title-group">
                          <span class="dashboard-hub-icon">
                            <i [class]="dashboard.icono"></i>
                          </span>
                          <div>
                            <span class="dashboard-hub-module-label">{{ dashboard.etiqueta }}</span>
                            <h6 class="mb-0">{{ dashboard.titulo }}</h6>
                          </div>
                        </div>

                        <a
                          class="btn btn-primary btn-sm dashboard-hub-primary-action"
                          [routerLink]="dashboard.dashboardLink"
                        >
                          Abrir
                          <i class="bi bi-arrow-up-right ms-1"></i>
                        </a>
                      </div>

                      <p class="dashboard-hub-description">{{ dashboard.descripcion }}</p>

                      @if (dashboard.accesos.length > 0) {
                        <div class="dashboard-hub-quick-access">
                          <span>Accesos rápidos</span>
                          <div class="dashboard-hub-quick-links">
                            @for (acceso of dashboard.accesos; track acceso.link) {
                              <a
                                [routerLink]="acceso.link"
                                [title]="acceso.etiqueta"
                                [attr.aria-label]="acceso.etiqueta"
                              >
                                <i [class]="acceso.icono"></i>
                                <span>{{ acceso.etiqueta }}</span>
                              </a>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </article>
                </div>
              }
            </div>
          } @else {
            <div class="dashboard-hub-empty-state">
              <span class="dashboard-hub-empty-icon"><i class="bi bi-shield-lock"></i></span>
              <h6>No tienes dashboards asignados</h6>
              <p>
                Tu usuario está activo, pero todavía no tiene acceso a un dashboard. Solicita al administrador de la
                cuenta que revise tus permisos.
              </p>

              @if (accesosAutorizados.length > 0) {
                <div class="dashboard-hub-empty-access">
                  <span>Opciones operativas disponibles</span>
                  <div class="dashboard-hub-authorized-links">
                    @for (acceso of accesosAutorizados; track acceso.link) {
                      <a [routerLink]="acceso.link">
                        <i [class]="acceso.icono"></i>
                        <span>{{ acceso.modulo }} · {{ acceso.etiqueta }}</span>
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </section>
      </div>

      <div class="col-12 col-xl-3">
        <aside class="dashboard-section dashboard-hub-notices">
          <div class="dashboard-section-header dashboard-section-header-compact">
            <div>
              <span class="dashboard-section-kicker"><i class="bi bi-bell me-1"></i>Comunicados</span>
              <h6 class="mb-0">Avisos</h6>
              <small class="text-muted">Información vigente para los usuarios</small>
            </div>
            @if (avisos.length > 0) {
              <p-tag [value]="avisos.length + ''" severity="info"></p-tag>
            }
          </div>

          @if (cargandoAvisos) {
            <div class="d-grid gap-2">
              <p-skeleton height="5rem"></p-skeleton>
              <p-skeleton height="5rem"></p-skeleton>
            </div>
          } @else if (avisos.length > 0) {
            <div class="dashboard-notice-list">
              @for (aviso of avisos; track aviso.id) {
                <article class="dashboard-notice" [ngClass]="obtenerClaseAviso(aviso)">
                  <div class="dashboard-notice-header">
                    <span class="dashboard-notice-icon">
                      <i [class]="aviso.icono || 'bi bi-info-circle'"></i>
                    </span>
                    <h6 class="mb-0">{{ aviso.titulo }}</h6>
                  </div>
                  <p>{{ aviso.mensaje }}</p>
                </article>
              }
            </div>
          } @else {
            <div class="dashboard-empty-state dashboard-empty-state-compact">
              <i class="bi bi-bell"></i>
              <h6>{{ errorAvisos ? 'No fue posible cargar avisos' : 'Sin avisos activos' }}</h6>
              <p>
                {{
                  errorAvisos
                    ? 'El panel principal sigue disponible. Intenta nuevamente más tarde.'
                    : 'No hay noticias, tips o recomendaciones para mostrar hoy.'
                }}
              </p>
            </div>
          }
        </aside>
      </div>
    </div>
  </section>
</main>
